import { createContext } from 'react'

export const FootnoteIndexContext = createContext<number>(0)
